import ApplicationController from '../../../../javascript/controllers/application_controller'

/**
 * Year Histogram Controller
 *
 * Makes the server-rendered bars one Tab stop: a roving tabindex, with the
 * arrow keys and Home/End moving focus between bars.
 *
 * Breadcrumbs:
 *   - Filter/year_filter_applied: When user clicks a histogram bar
 *
 * @extends ApplicationController
 */
export default class extends ApplicationController {
  static targets = ['bar']

  navigate(event) {
    const bars = this.barTargets
    const current = bars.indexOf(event.target)
    if (current === -1) return

    const next = this.nextIndex(event.key, current, bars.length)
    if (next === null) return

    event.preventDefault()
    bars.forEach((bar, index) => {
      bar.tabIndex = index === next ? 0 : -1
    })
    bars[next].focus()
  }

  track(event) {
    this.addBreadcrumb('Filter', 'year_filter_applied', {
      year: event.currentTarget.value,
    })
  }

  nextIndex(key, current, count) {
    switch (key) {
      case 'ArrowRight':
        return Math.min(current + 1, count - 1)
      case 'ArrowLeft':
        return Math.max(current - 1, 0)
      case 'Home':
        return 0
      case 'End':
        return count - 1
      default:
        return null
    }
  }
}
